const API_BASE = process.env.REACT_APP_EMAIL_LISTS_API_URL; 

let cached = null;

export async function getEmailLists() {
  if (!API_BASE) {
    return { whitelist: [], blacklist: [] };
  }
  if (cached) return cached;
  try {
    const [w, b] = await Promise.all([
      fetch(`${API_BASE}/lists/whitelist`).then((r) => r.json()),
      fetch(`${API_BASE}/lists/blacklist`).then((r) => r.json()),
    ]);
    cached = {
      whitelist: w.items || [],
      blacklist: b.items || [],
    };
    return cached;
  } catch (e) {
    console.warn('Email lists fetch failed', e);
    return { whitelist: [], blacklist: [] };
  }
}

export function getCachedEmailLists() {
  return cached;
}